import Base from '../base';

const VALIDATION_MESSAGE_DEFAULT = 'Make sure to meet the requirements';

class CheckboxSelectionValidation extends Base {
	constructor(el, options) {
		super(el, options);

		this.minCheckedCount = this.options.minCheckedCount || 1;
		this.validationMessage = this.options.validationMessage || VALIDATION_MESSAGE_DEFAULT;

		this.checkboxes = this.queryAll('input[type=checkbox]');
	}

	start() {
		this.on('change');

		this.setRequired(true);
	}

	onChange() {
		this.checkValidity();
	}

	checkValidity() {
		const isValid = this.checkRequirements();

		this.updateValidation(isValid);
	}

	checkRequirements() {
		const checked = this.checkboxes.filter(c => c.checked);
		const count = checked.length;

		return count >= this.minCheckedCount;
	}

	updateValidation(isValid) {
		const [first] = this.checkboxes;
		const customValidity = isValid
			? ''
			: this.validationMessage;

		this.el.classList.toggle('is-invalid', !isValid);
		this.refs.validationMessage.classList.toggle('is-hidden', isValid);

		first.setCustomValidity(customValidity);

		this.setRequired(!isValid);
	}

	setRequired(isRequired) {
		const [first] = this.checkboxes;

		first.required = isRequired;
	}
}

export default CheckboxSelectionValidation;
